import React from "react";
import styled from "styled-components";

const GalleryWrapper = styled.ul`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0;
  z-index: 2;
`;

export default GalleryWrapper;



// WEBPACK FOOTER //
// ./src/styled-components/GalleryWrapper.js